<template>
    <span class="wrapper">
        <keep-alive>
            <MapSelectorModal v-if="showMapSelector" :initialDescription="locationDescription" :initialCoordinates="locationCoordinates || currentCoordinates" @save="saveMapSelector" @close="closeMapSelector"/>
        </keep-alive>
        <Autocomplete class="search-location"
                      v-on:select="select"
                      placeholder="Trail Location"
                      :cancellable="false"
                      :initializeWhenDone="false"
                      :loadingCount="loadingCount"
                      :options="options"
                      v-bind:value="search"
                      v-on:input="$emit('input', search = $event)">
            <template v-slot:item-currentLocation="{input}">
                    <span style="white-space: normal; max-width: 100%;">
                        <span class="currentLocationItem">
                            <span class="location-icon purple">near_me</span>
                            {{input || currentLocation.formatted_address}}
                        </span>
                        <span class="currentLocationItem"> @<MapCoordinates :coordinates="currentCoordinates"/> (Current Location)</span>
                    </span>
            </template>
            <template v-slot:item-selectOnMap>
                <span class="location-icon purple">gps_fixed</span>
                <span> Select on Map</span>
            </template>
            <template v-slot:item="{option}">
                <span class="location-icon" style="color: grey">location_on</span> {{option.description}}
            </template>
        </Autocomplete>
    </span>
</template>

<script>
  export default {
    name: "EditableLocationAutocomplete",
    props: {
      locationCoordinates: {type: Object},
      locationDescription: {type: String},
      autocompleteSessionTokenPromise: {type: Promise},
      currentCoordinates: {type: Object},
      currentLocation: {}
    },
    data() {
      return {
        search: this.locationDescription,
        results: [],
        loadingCount: 0,
        remoteOptions: [],
        showMapSelector: false
      };
    },
    computed: {
      options() {
        let options = this.remoteOptions;
        if (this.currentCoordinates) {
          options.push({slotKey: "currentLocation"});
        }
        options.push({slotKey: "selectOnMap"});
        return options;
      }
    },
    methods: {
      select(location) {
        if (!location) {
          //Text updated without selecting something - update just description
          this.saveMapSelector(this.locationCoordinates, this.search);
        } else if (location.slotKey === "currentLocation")  {
          this.saveMapSelector(this.currentCoordinates, this.search || this.currentLocation.formatted_address);
         // this.showMapSelector = false;

//          this.$el.click();//TODO better way to blur;

        } else if (location.slotKey === "selectOnMap") {
          this.showMapSelector = true;
        } else {
          let placesService = new google.maps.places.PlacesService(document.createElement('div'));
          let locationPromise = this.autocompleteSessionTokenPromise.then(autocompleteSessionToken => {
            return new Promise((resolve, reject) => {
              placesService.getDetails({placeId: location.place_id, sessionToken: this.autocompleteSessionToken}, (place, status) => {
                if (status !== google.maps.places.PlacesServiceStatus.OK) {
                  reject(status);
                  throw status;
                }
                resolve(place);
              });
            });
          });
          this.$emit('select', locationPromise.then(
            place => {place.description = location.description; return place}
            )
          );
        }
      },

      saveMapSelector(newCoordinates, description) {
        let lat = newCoordinates.lat;
        let lng = newCoordinates.lng;
        let placePromise = Promise.resolve({
          description: description,
          geometry: {
            location: {
              lat() { return lat},
              lng() { return lng}
            }
          }
        });
        this.search = description;
        this.$emit('select', placePromise);
        this.closeMapSelector();
      },
      closeMapSelector() {
        this.showMapSelector = false;
      },

    },
    watch: {
      search(search) {
        if (!search) {
          return [];
        }
        let service = new google.maps.places.AutocompleteService();
        let placePredictionPromise = new Promise((resolve, reject) => {
          service.getPredictions({input: search, fields: ['geometry'], sessionToken: this.autocompleteSessionToken}, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              resolve(predictions);
            } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
              resolve([]);
            } else {
              reject(status);
              throw status;
            }
          });
        });
        placePredictionPromise.then(predictions => {
          if (this.search === search) {
            this.remoteOptions = predictions;
          }
        });
      }
    }

  }
</script>

<style scoped lang="scss">
    .wrapper {
        width: 100%;
        /*position: relative;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        //align-items: center;
    }

    .currentLocationItem {
        max-width: 100%;
        display: inline-block;
        white-space: pre;
        text-overflow: ellipsis;
        overflow: hidden

    }

    .purple {
        color: $beaverpurple2;
    }
    .location-icon {
    @extend .material-icon;

    }

    .search-location {
        width: 100%;
        display: flex;
        //justify-content: center;
    }

    .search-location::v-deep input, .search-location::v-deep .autocomplete-results {
        width: 100%;
        text-align: center;
    }

    .search-location::v-deep .autocomplete-results {
        font-size: 12px;
    }

</style>
